import React from "react";
import dayjs from "dayjs";

function MessageA2(props) {



  const messageTimeStyle = () => {
    let config = props.config;
    return config?.customDesign?.messageA2Time;
  }



  return (
    <div style={{ maxWidth: '90%', overflowX: 'hidden', wordWrap: 'break-word' }} >

      <div


        dangerouslySetInnerHTML={{ __html: props.entry.text }}
      ></div>
      {props.isLastEntry && props.sentTimestamp && <div className="s360-message-time-received" style={messageTimeStyle()}>{dayjs.unix(Math.trunc(props.sentTimestamp / 1000)).format("DD MMM h:mm a")}</div>}
    </div>

  );
}

export default MessageA2;
